import type * as React from "react"
import { useLingui } from "@lingui/react"

import { HelpTip, type HelpTipProps } from "@/components/ui/help-tip"

export interface FormulaTipProps {
  /** How the figure is calculated: the variables and how they combine, in a line or two. */
  content: React.ReactNode
  side?: HelpTipProps["side"]
  align?: HelpTipProps["align"]
  className?: string
  "data-testid"?: string
}

/**
 * An info icon next to a figure, chart or card title that says how the number
 * is calculated. Opens on hover, click and keyboard focus (see HelpTip).
 */
export function FormulaTip({ content, side, align, className, "data-testid": testId = "formula-tip" }: FormulaTipProps) {
  const { i18n } = useLingui()
  return (
    <HelpTip
      icon="info"
      content={content}
      label={i18n._({ id: "ui.formulaTip.label", message: "How this is calculated" })}
      side={side}
      align={align}
      className={className}
      data-testid={testId}
    />
  )
}
